/**
 * @exports replaceDecimalSeparator
 * @since 2.9.0
 */
import { CONVERTER_DEFAULTS } from '../CurrencyConverter/constants';

/**
 * Replace floating point numbers' decimal by given possibleSeparators separator to a given "to" separator
 * @param  {String|Number} num Number representation
 * @param  {String} [options.decimalSeparator='.']       marks the decimal separator of the number
 * @param  {String} [options.possibleSeparators='[,/.]'] marks the possible separators to search and replace
 * @return {String} String where the decimal point is set by given "to" parameter
 *
 * @example
 * replaceDecimalSeparator('33,22') = '33.22';
 * replaceDecimalSeparator('33.22', {decimalSeparator:','}) = '33,22';
 */
export const replaceDecimalSeparator = (num, { possibleSeparators = '[,\\.]', decimalSeparator = CONVERTER_DEFAULTS.decimalSeparator } = {}) => num.toString().replace(new RegExp(`${possibleSeparators}(\\d{2})($|[^\\d])`, 'g'), `${decimalSeparator}$1$2`);
